import styled from '@emotion/styled';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';

export const MortgageCalculatorRoot = styled.div`
  ${({ theme }) => `
    padding: ${theme.spacing(4)} ${theme.spacing(3)};
    border-radius: 24px;
    box-shadow: ${theme.shadow.level7};
    border: 1px solid ${theme.colors.neutrals.grey8};
    background-color: ${theme.colors.neutrals.white};
    color: ${theme.colors.neutrals.grey1};
    margin: ${theme.spacing(5)} 0;
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding: ${theme.spacing(4)} ${theme.spacing(7)};
    margin: ${theme.spacing(4)} 0;
  `}
`;

export const MortgageCalculatorHeader = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.spacing(1)};
    flex-direction: column-reverse;
    margin-bottom: ${theme.spacing(3)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}
`;

export const MortgageCalculatorDisclaimer = styled.div`
  ${({ theme }) => `
    font-size: 9px;
    line-height: ${typographyLineHeightCfg.textLabel.small}px;
    text-align: center;
    margin-top: ${theme.spacing(3)};
    display: flex;
    flex-direction: column;
  `}
`;

export const MortgageCalculatorLink = styled.a`
  ${({ theme }) => `
    text-decoration: none;
    display: block;
    color: ${theme.colors.neutrals.white};
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    padding: ${theme.spacing(1.5)};
    border-radius: ${theme.borderRadius.extraXLarge};
    background: linear-gradient(90deg, #B91235 0%, #E02819 100%);
    text-align: center;
    margin: ${theme.spacing(3)} auto;
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    width: 270px;
  `}
`;

export const MortgageCalculatorContent = styled.div`
  ${({ theme }) => `
    display: flex;
    margin: ${theme.spacing(3)} 0;
    border-radius: ${theme.borderRadius.large};
    border: 1px solid ${theme.colors.neutrals.grey8};
    background-color: ${theme.colors.neutrals.grey10};
    padding: ${theme.spacing(2)};
  `}
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    flex-wrap: wrap;
  `}
`;
export const MortgageCalculatorItem = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    flex-basis: 50%;
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    flex: 1 1 0;
    &:not(:first-of-type) {
      border-right: 1px solid ${theme.colors.neutrals.grey6};
    }
  `}
`;

export const MortgageCalculatorItemInterest = styled(MortgageCalculatorItem)`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    flex-basis: auto;
    min-width: 0;
  `}
`;

export const MortgageCalculatorText = styled.div`
  ${({ theme }) => `
    font-size: ${typographyFontSizeCfg.textLabel.small}px;
    line-height: ${typographyLineHeightCfg.textLabel.small}px;
    text-align: center;
    color: ${theme.colors.neutrals.grey2};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    text-align: initial;
  `}
`;
export const MortgageCalculatorValue = styled.div<{ isPrice?: boolean; }>`
  ${({ isPrice }) => isPrice && 'color: #ED1C24;'}
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  font-weight: 700;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    text-align: initial;
  `}
`;

export const SeparatorLine = styled.div`
  display: none;
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    display: block;
    width: 100%;
    margin: ${theme.spacing(1.5)} 0;
    background-color: ${theme.colors.neutrals.grey8};
    height: 1px;
  `}
`;

export const MortgageCalculatorSliderLegend = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MortgageCalculatorItemsLine = styled.div`
  display: flex;
  min-width: 0;
  flex-grow: 1;
  justify-content: space-between;
  flex-wrap: wrap;
`;
